// extracted by mini-css-extract-plugin
module.exports = {"section":"Trailer_section__258XY","div":"Trailer_div__1GEO4","svg":"Trailer_svg__2k-q-","focus":"Trailer_focus__2DOMj","ribbon":"Trailer_ribbon__3SIdq"};